var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      staticClass: "custom-resizable",
      attrs: {
        draggable: false,
        resizable: !_vm.disabledResize,
        handles: _vm.handles,
        onResize: _vm.onResize,
        maxWidth: _vm.maxWidth,
        minWidth: _vm.minWidth,
        w: _vm.width,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }